// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Zfz","left":"styles_left__2DJMF","desktopActions":"styles_desktopActions__1M6pg","title":"styles_title__16p3b"};